module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "height": "0pt"
    },
    attrs: {
      "id": "id_Toc39728744"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_114",
    attrs: {
      "id": "id_Toc146373210"
    }
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("Chapter Four"), _c('br', {}), _vm._v("Crazy Truths")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Shannon and Martin had gone out to scavenge the back of charity disposal stores. They often would bring back bags of donated goods to rummage through. I used to think that was like my birthday or Christmas in our household. Ripping open the black garbage bags and pulling out the guts of a stranger’s goodwill.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("These walls were lined with stolen favours. Boutique tablecloths, throws and cutlery from restaurants I had never stepped foot in. Our couch looked like regurgitated spaghetti and meatballs, possibly because it had been taken from somebody’s front yard. I sat stiffly with over-worked eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I could not rest for too long. Martin had warned me of paedophiles, murderers, rapists, and burglars. Being home alone, ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("especially")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" at night, ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("especially")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" as a girl, was dangerous.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Shannon had once said, “Stay there, I’ll have Martin show you a few things.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Martin pulled a dark green lighter out from his jeans. He began licking and kissing it, demonstrating how men could use their mouths to entice a woman. “Be careful if they smooch your ears or try complimenting you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I permitted myself to stare blankly at the floor and disappear.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Shannan jolted me back with a whack across the head. A tightly wound magazine firmly in her grip she flung it into my lap. I unrolled the creases and saw a topless brunette staring back at me. My hands felt clammy as she rambled on about grooming myself properly.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I just wanted them to stop bombarding me with sexual information.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I eventually got dismissed and sat in the corner of my room. My brows furrowed at the idea of some woman lying on her bed, completely naked, completely exposed, and just letting someone take her picture. As I flipped awkwardly, I couldn’t find any slimy tunnels running through the bodies of these women. I tossed it.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I hated recalling uncomfortable events in my life, but I kept doing it. “Stop thinking,” I said. I rubbed by eyes and willed them to remain open, here in the present again. Moving towards the window, I watched the cars passing over the main road. I could see them zooming by, carrying models, lawyers, waitresses and doctors out there in their happy world.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Maybe they knew a secret to living that I hadn’t learnt yet? Or maybe they were busy sneaking around in my front yard.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Leaning in closer to have a better look, I squinted at my blank dark lawn. Someone ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("was")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" outside of my house! I could see as he looked over his shoulder and then walked towards my front door. The resonance of the doorbell flew across the halls, bounced off the walls, and reached the hairs on the back of my neck.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I walked to the door with weak knees and hated myself for being afraid. I couldn’t help myself; a burglar would storm in and knock me down. He would point his gun at my head and make me hand over Shannon’s money. A paedophile would con his way inside, with smiles and sweets, and kidnap me to play house in his basement. A rapist would—")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("It was Zack.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“You said I could keep the jacket,” I blurted out. My heart pounded loudly. My fingers tightening their grip around the sleeves. “I mean, I thought you had gone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Standing across from me in an identical jacket, his lips curled into a grin. Brown hair casually fell over his dark eyes. “You were alone—because I can see there are no cars in the driveway—so I thought it would be a good time.” He smiled and so I let him in. His voice sounded so warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I wondered for a moment if I would get in trouble for having a guest. Having a ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("boy ")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v("over while the parents were away, seemed extremely taboo. I was certain Shannon could have cameras or somebody spying on me. I looked over his shoulder to see if anyone was peeping out of their windows, and then came back to his gaze. My heart ached at the thought; strangers are sometimes murderers too. Was that what I wanted?")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“So,” I closed the door behind us. “I am glad that you came back. I wanted to thank you for listening to me the other night. I know it must have been very inconvenient.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("His eyes examined me carefully, as if tracing for some kind of injury that needed tending to, and it made me nervous. I gulped. There grew a feeling of red on my cheeks, so I decided to start walking into the lounge room. I motioned to offer him a seat.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“You are definitely not an inconvenience, Hope.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I must have told him my name between sobs.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Hope,” Zack said it again. “If anything, it is actually ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("convenient")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(". It’s very convenient that you are here. Alone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("That felt ominous.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I didn’t really know this man at all, not really. Had I been in such a depressed state I had forgotten? Perhaps I didn’t want to die… I just wanted the pain to stop. Death makes the pain stop. If I was brave, I’d let him make the pain stop. I just—")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I swished my body around to face him squarely, trying desperately to remember if I’d told him my name when we first met. I supposed my mother was right after all; Stalkers existed just as much as murderers and rapists. You never know what kind of monster you will get. ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("Was he going to lick my ears now? And why did he look so confused?")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I’m not speaking as eloquently as I sound in my head.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Probably accurate.” I nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Zack held his hands up where I could see them. “I have to tell you something important, so that’s why it’s good that you’re alone. Can we sit down?” He ran a hand through his hair and indicated the barf couch.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I actually have a lot of homework.” I sat down obediently. I clutched at my knees as he came and filled my nostrils with the scent of his aftershave. He placed his hands calmly onto his knees, just like mine, and simpered.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I’ve known your name and didn’t tell you,” he confessed. “I apologise for frightening you with that. I should have been more tactful. I guess I’m just a bit nervous because I wanted to do this correctly and I’ve already done quite poorly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Are you a spy?” I asked, shocking even myself, but realising it may have been the only logical explanation; one of Shannon’s spies getting caught on the job and now he’s here to confess it all. Maybe he felt guilty.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I wasn’t spying on you exactly. Actually, I was meant to have met you here, in this house, but when I stumbled into you at the park, I just got lost in the moment. I couldn’t leave a girl crying alone in the park, you know?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“You knew who I was?” I blinked, struggling to follow exactly what he was admitting to.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yes, and it has taken me a long time to find you,” he stated earnestly. “A co-worker of mine found you. She was involved in a case with a young boy called Steven; I believe he used to live next door to you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yes…” I squinted.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yes, well, she ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("found")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" you!” Zack looked ecstatic for a split second, and then seeing my solitary confusion, he added, “I mean, he told her about you, and she called me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I thought of Steven then; the little boy next door who Shannon had sent out to purchase weed from the local dealers. He had been so innocent and so pure, and then Shannon got him mixed up with so many terrible people. He could have been buying bread and butter from those criminals and it still would have been a dangerous outing for a child.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Is Steven okay?” I realised that perhaps I was talking to a social worker. This meant I had to remember the rules. ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("Home problems stay at home. Tell them the truth, but don’t tell them anything that will get Mother and Father in trouble. Tell them the truth, but don’t make Mother out to be the bad guy. You could be taken away and you will break everyone’s hearts. But still, tell them the truth.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Steven is doing well.” He paused intently, as though listening for something, and continued, “I do a special kind of work, it’s a little complicated to explain, but I don’t work for the government and I’m not a social worker.” Zack reached his hand out to touch my own, which I had neglected to unclench from my knees. “I often help people who really need it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Oh okay, good.” I moved my hand away from him, feeling startled by the contact. “Well, I’m perfectly fine! Steven was a nice boy. I’m so glad he’s doing well. I’m not doing drugs, and so I’m fine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Drugs?” He frowned. “That’s good.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yeah, so I don’t need anything, thank you.” We sat silently for a moment, the awkwardness climbing as his eyes bore deeply into my own. I heard the sound of my heel bouncing up and down against the carpet, and I hated that, so I stopped. Zack seemed to be weighing up his next words very carefully.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Well, is there anything familiar about me to you? Maybe the way I smell? Or speak?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Of course,” I admitted without thinking. “I mean, I wasn’t sniffing you—” I felt a blush rush over my cheeks again. “I mean, it was only yesterday, and I have a very keen sense of smell. I have a good nose for smells,” I rambled. “But not an abnormal sense, just a good normal smelling nose.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Zack’s eyes lit up. “That’s a really good quality to have.” He chuckled. “But more specifically, I am referring to prior events. Do you recall anything from 19 years, 7 months, and 14 days ago?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“So, when I was born?” I calculated with confusion. “You think I smelt you when I was a baby?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Uh, not exactly.” He frowned and continued slowly. “I’m talking about before ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("that")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(", before you came here.” He waited a second for some kind of response and then continued, “I wish there were an appropriate way to say this, but this ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("life")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" is not real. You’re being manipulated and punished…this is all a lie.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Zack waved his hand at my surroundings and I leaned back with a stiff spine and wide eyes. He definitely wasn’t a social worker. I had let in a ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("crazy person")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(". I stood up and pretended to be calm. I walked across to the other side of the room and leaned against the wall. Then I considered my options:")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('ol', {
    staticClass: "list_"
  }, [_c('li', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("run away and hope he doesn’t catch me.")])]), _vm._v(" "), _c('li', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("agree with everything he says and hope he doesn’t try to kill me, or")])]), _vm._v(" "), _c('li', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("accept that I could die tonight.")])])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Is this a metaphorical kind of discussion?” I squinted at him. “When you say my life is not real…”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“No, I’m being quite literal. I’ve watched over you since we found you. I can see how this is all laid out.” Zack then stood up also and walked around the room. “You’ve been monitored by all kinds of people. Rogues planted at school, in your home, along the street. I think they assume I’m just another one of their crew.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I think you should leave.” I heard my voice tremble. Zack had bigger forearms, longer legs, stronger hands… I felt a clamminess to my feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I want you to think for a moment.” His hands slowly came up where I could see them. “Doesn’t it feel to you like everyone in your life—or everyone who plays an integral role—is not quite authentic in their intentions?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("My eyes twitched. I felt myself agree with his insanity. I pulled my sleeves down over my hands and shook.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Okay, what if I told you that you had been made a clean slate? Your memory, taken from you. Your body’s ageing process was re-wound, ready for a newly orchestrated life. Everything was ta—”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I think you really should go, okay? Please?” I pushed myself tightly against the wall. His dark eyes looked dangerous to me now. He was a stream of madness. I felt ashamed that I had opened up so much to this unbalanced stranger.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Alright.” He took a few steps closer to me, leaning in, with his left palm against the wall. He spoke tenderly over me. “First, just look into my eyes and tell me you don’t remember me at all.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I don’t remember you at all.” His brown eyes moved to and fro, the freckles on his nose sweetly deceptive, the breath warming over my skin, and lips I had never foolishly fixated over—no, I had never met this man before yesterday.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Okay.” He shook his head and pushed himself away from the wall. “Okay, so you really don’t remember me at all, but—” He turned his back to me then, and I ran for it. I rushed towards the staircase, I looked back, but he was not there. I ran into the bathroom and locked the door behind me. My chest rose and fell as I found myself all adrenaline and terror.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("What was going to happen next? My eyes darted to the bathroom sink and I reached for Shannon’s razor blades. I heard footsteps slowly making their way up the stairs and then a knock on the door. I stood with my shoes planted on the black and white tiles. My thumb ran across the back handle of the blade.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Hope.” I heard a sigh. “I’m not going to break down the door. You’re safe. You can put the razor down and relax, okay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Is this some kind of sick game? You have cameras in here too?” I started to look around wildly searching for some kind of lens or peeping hole. ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("How did he know?")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I can read your mind. When you get highly emotional,” he said. “Will you let me explain?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Okay, fine!” I said. “You can talk from out there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I stared at the white door and brown nob. It did not move. He did not push or twist to open it.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I’m here to save you,” Zack said quietly. “I’m here to rescue you from this whole thing. You were stolen from me, from us. I have to force this, as soon as Nathan learns that I’m here, he’s going to take you away again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I stepped into the middle of the bathroom and crouched down. My arms wrapped around my knees and my fingers clenched the handle of the razor. My blonde hair fell before my face as shards of truth pushed through the absurdity of it all. ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("Could he read my mind? Was my whole life a lie?")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Nathan,” I mumbled, something striking me familiar. “Nathan is the name of this person?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yes, does that mean something to you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“How is that possible?” I felt the hard-plastic handle of the blade pushing into my palm sharply, as were the thoughts that were pushing sharply into my mind. “How does a person take a memory? Magic? Is ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("that")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" your whole spiel?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“It’s not magic,” he said. “It’s just a stupid loophole in the system. We can be restarted, so that if any of us goes mad or dangerous, we don’t have to be killed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I have no idea what you’re even saying now.” I felt my eyes welling up; ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("was I going crazy?")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" Maybe… I thought…")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("maybe")]), _c('span', {
    staticClass: "text_6"
  }), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("Zack wasn’t even here.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I am real, Hope,” he answered my unspoken question. Yet I knew that a figment of my imagination would easily know what was happening inside my mind. I stood up and began pacing—thinking things through—muttering to myself…")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“If I’m insane,” …")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("then I may as well disappear with Zack. Maybe Martin and Shannon were right all along—all the pain has just been in my head. Being ‘sensitive’, being ‘fake’, being ‘dirty’; it was all just in my head.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Zack can’t possibly exist.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Hope,” he sounded urgent. “Please open the door.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("And so, I did. I came outside and looked into his dark brown eyes. I looked into the oh-so-realistic formation of this person who no one else had ever seen or witnessed. Surely, he wasn’t real…")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("right? ")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v("I leaned against the creamy wallpaper and continued to grip the plastic handle. “Are you going to take me away to somewhere better than this place?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I would like to.” His eyebrows drew together with sympathy.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“And you thought I’d remember you because of your smell?” I loosened my grip.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Well, your sense of smell activates your brain’s amygdala and parahip—” he cut himself off mid-sentence and shook his head. “I had hoped you would recall something, yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I placed the razor into my pocket and looked at my shoes.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I think we need to go, as soon as possible.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I’m not sure.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I know you don’t trust me.” He rubbed his shaded jawline with a solemn expression. “But your parents are the ones who have been lying and manipulating you. They aren’t your real parents.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Okay,” I encouraged him to talk. “Because I would like that to be true.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Nathan recruited impaired people to make an example of you. To send a message to your dad. Your real one.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Sure.” I tried to see if he would fade away. If I ignored him, or if I demanded myself to realise he wasn’t actually there, what would happen? But he kept talking to me, and even reached out to touch my wrist. Sliding two warm fingers across my skin, and it seemed so life-like.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Your dad and Nathan have a history. Your dad disappeared to protect himself and Nathan came after you in retaliation. Now we have to go.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“So, I need to just pack a bag and leave?” I repeated the idea.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yes.” He nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“And you want me to believe that you can read my mind, and that I lived years and years before I was born, and that my parents aren’t really my parents, and that some guy out there wants me dead—but hasn’t taken the time to kill me yet?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yes, and I can explain everything in much more detail once we leave.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("The sound of the front door slamming made my head spin. I could hear the familiar thuds of Shannon storming around and a particular coughing sound from Martin. They were home, and Zack was standing in front of me.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Zack held a finger up to his lips and took a step closer to my side. I felt empowered by my own insanity. I imagined perhaps that I might be found out having a mental breakdown and then sent off to an asylum. The nurses would let me rest, at last.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I pushed him off me and started down the stairs. I imagined what expression must have been on his face, but I looked ahead with tunnel vision. It was like an out-of-body experience until my eyes came upon Shannon’s round-angry-head. I fell back into the same trepidation I knew only too well. Like a five-year-old who is always waiting for their beating. I gulped back my false courage and froze on the spot.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“This is un-be-lievable.” Shannon had her teeth gritted and pointed one thick finger at my face. “You think money grows on trees? Leaving all the lights on throughout the house; this is why my fashion company idea never took off the ground. ALL MY MONEY GOES TO PAYING FOR YOU.” She spat the last sentence out so close to my face that I felt the spit land on my cheeks.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I felt also the knots binding inside of me. I looked around for Martin but he had drunkenly wandered off into the kitchen. “I was just down here a moment ago. I just went upstairs. I was coming right back. I’m sorry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Tie up your hair.” Shannon knew I often hid behind my hair to feel safer. I turned to look around for a hair tie and saw Zack walking towards us. Shannon pulled her head back and clicked her jaw.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Hello there.” He stood by my side and placed a protective hand on the small of my back.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Of course, you’re letting boys in.” Shannon’s snarl showed the gap between her front teeth as she said, “Go home, don’t come back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Zack lowered his hand to his side and raised both of his eyebrows at Shannon. “You’re not really equipped to order people around.” He briefly looked her over. “I can already hear the murmuring thoughts of aches and pains in your back, your liver, your lungs. I am going home and taking Hope home with me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Shannon made an expression I was unfamiliar with. Her jaw dropped slightly, and from the corner of my eye, I could see Martin drunkenly by the doorway, looking pale as a ghost. ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("Was this real?")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Martin, make the call,” Shannon said sharply. I saw him stumble around to the phone and shakily feel for something underneath the table. A post-it note which had been taped underneath was clumsy between his fingers. Shannon gave Zack a deathly stare. “You know what this means, he will come for you next.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I’m going to take Hope off of your hands.” Zack reached out and held the back of my elbow firmly. “And if Nathan sends you or ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("anyone")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" after her again, then I will kill him, and ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("you")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" will be next.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“You won’t have her for very long.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I heard Martin stumble into the wall as he struggled to dial a simple number into his phone. I heard the voices of Zack and Shannon. I felt the real contact of Zack touching my arm, and I wondered where my blob of lavender moisturiser was. “Mum?” A tiny voice emitted from my lips, and I felt hurt, and small, and a sense of disgust.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I often avoided using the words ‘mum’ or ‘dad’, but in this moment, I felt so betrayed and desperate that I reached out of fear. Every little girl wants her mother and father to love her. I had always loathed myself for not being good enough for loving and spending time with. I knew now that Shannon didn’t love me for another reason; because I wasn’t really hers.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("Ooh, Mummy!” ")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v("Shannon waved her hands and mocked me. ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("“I’m so scared, I don’t want to sleep in the dark; I have no friends; why don’t you love—”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Zack stepped forward and twisted Shannon’s arm around her back. Swiftly walking her to the side of the room, he pinned her against the wall and whispered so I could not hear. Martin gasped but did not contribute. She groaned loudly as he swung her back around and told her to stay.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Zack’s hand returned to me, guiding me out the door at a hasty pace.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I saw at a distance my tiny feet taking steps across the grey asphalt. My everything fell apart. I struggled to lift my feet; wobbly knees, sweaty palms. The house sighed with me.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_7"
  }, [_vm._v("Had I completely lost my mind?")])]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_c('span', {
    staticClass: "text_3"
  }, [_c('br', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_13"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b1df142","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_008.vue
// module id = 87
// module chunks = 0